import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';

const InputCentreGrid = props => {
  const { children, style, className } = props;

  return (
    <Col
      xs={{ span: 20, offset: 2 }}
      sm={{ span: 20, offset: 2 }}
      md={{ span: 20, offset: 2 }}
      lg={{ span: 6, offset: 2 }}
      xl={{ span: 6, offset: 1 }}
      style={style}
      className={className}
    >
      {children}
    </Col>
  );
};

InputCentreGrid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  style: PropTypes.object,
  className: PropTypes.string,
};

export default InputCentreGrid;
